"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const yup = require("yup");
exports.USER_VALIDATIONS = {
    EMAIL_MIN: 5,
    EMAIL_MAX: 255,
    USER_NAME_MIN: 5,
    USER_NAME_MAX: 15,
    PASSWORD_MIN: 3,
    PASSWORD_MAX: 255,
};
exports.USER_ERR_MESSAGES = {
    FORGOT_PASSWORD_EXPIRED_KEY: "Forgot link has expired",
    INVALID_CREDENTIALS: "invalid credentials",
    CONFIRM_EMAIL: "please confirm your email",
    FORGOT_PASSWORD_ACCOUNT_LOCKED: "account is locked",
    DUPLICATE_EMAIL: "Email already exists",
    DUPLICATE_USER_NAME: "User Name already exists",
    LOGIN_OR_REGISTER: "Please Login or Register",
    USER_NOT_FOUND: "could not find user with that email",
    USER_NOT_EXIST: "User does not exist anymore",
    USER_NOT_AUTHORISED: "user not authorised to make specified changes",
    INVALID_EMAIL_FORMAT: "email must be in valid format",
    EMAIL_NOT_VALID: `Password should be between ${exports.USER_VALIDATIONS.EMAIL_MIN} and 
		${exports.USER_VALIDATIONS.EMAIL_MAX} characters`,
    PASSWORD_NOT_VALID: `Password should be between ${exports.USER_VALIDATIONS.PASSWORD_MIN} and 
		${exports.USER_VALIDATIONS.PASSWORD_MAX} characters`,
    USER_NAME_NOT_VALID: `User name should be between ${exports.USER_VALIDATIONS.USER_NAME_MIN} and 
		${exports.USER_VALIDATIONS.USER_NAME_MAX} characters`,
};
exports.emailValidation = yup
    .string()
    .required()
    .min(exports.USER_VALIDATIONS.EMAIL_MIN, exports.USER_ERR_MESSAGES.EMAIL_NOT_VALID)
    .max(exports.USER_VALIDATIONS.EMAIL_MAX, exports.USER_ERR_MESSAGES.EMAIL_NOT_VALID)
    .email(exports.USER_ERR_MESSAGES.INVALID_EMAIL_FORMAT);
exports.passwordValidation = yup
    .string()
    .required()
    .min(exports.USER_VALIDATIONS.PASSWORD_MIN, exports.USER_ERR_MESSAGES.PASSWORD_NOT_VALID)
    .max(exports.USER_VALIDATIONS.PASSWORD_MAX, exports.USER_ERR_MESSAGES.PASSWORD_NOT_VALID);
exports.userNameValidation = yup
    .string()
    .required()
    .min(exports.USER_VALIDATIONS.USER_NAME_MIN, exports.USER_ERR_MESSAGES.USER_NAME_NOT_VALID)
    .max(exports.USER_VALIDATIONS.USER_NAME_MAX, exports.USER_ERR_MESSAGES.USER_NAME_NOT_VALID);
exports.userValidationSchema = yup.object().shape({
    email: exports.emailValidation,
    userName: exports.userNameValidation,
    password: exports.passwordValidation,
});
exports.emailUserNameValidationSchema = yup.object().shape({
    email: exports.emailValidation,
    userName: exports.userNameValidation,
});
exports.loginValidationSchema = yup.object().shape({
    email: exports.emailValidation,
    password: exports.passwordValidation,
});
exports.changePasswordValidationSchema = yup.object().shape({
    newPassword: exports.passwordValidation,
});
//# sourceMappingURL=user.js.map


//////////////////
// WEBPACK FOOTER
// ../common/dist/yupSchemas/user.js
// module id = 745
// module chunks = 0